var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDelayed),expression:"isDelayed"}],staticClass:"spinner"},[_c('div',{staticClass:"spin"})])])}
var staticRenderFns = []

export { render, staticRenderFns }